import { defineMessages } from 'react-intl'

const scope = `procurify.purchasing.discover-contracts.page`

export default defineMessages({
  discoverContractsPageTitle: {
    id: `${scope}.discoverContractsPageTitle`,
    defaultMessage: 'Contracts',
  },
})
